import React from "react";
import { ButtonWrapper } from "../styles/Button.style";
import { RegisterProp } from "../data-types/types";

export const Button: React.FC<RegisterProp> = ({ goToRegister }) => {
  return <ButtonWrapper onClick={goToRegister}>Click to start</ButtonWrapper>;
};
